var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateImO(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#ECD0EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 24C15 23.45 15.45 23 16 23C16.55 23 17 23.45 17 24C17 24.55 16.55 25 16 25C15.45 25 15 24.55 15 24ZM20 23H24C24.55 23 25 23.45 25 24C25 24.55 24.55 25 24 25H20C19.45 25 19 24.55 19 24C19 23.45 19.45 23 20 23ZM26 28H14C13.449 28 13 27.551 13 27V21H27V27C27 27.551 26.551 28 26 28ZM14 14H15V15C15 15.55 15.45 16 16 16C16.55 16 17 15.55 17 15V14H23V15C23 15.55 23.45 16 24 16C24.55 16 25 15.55 25 15V14H26C26.551 14 27 14.449 27 15V19H13V15C13 14.449 13.449 14 14 14ZM26 12H25V11C25 10.45 24.55 10 24 10C23.45 10 23 10.45 23 11V12H17V11C17 10.45 16.55 10 16 10C15.45 10 15 10.45 15 11V12H14C12.346 12 11 13.346 11 15V27C11 28.654 12.346 30 14 30H26C27.654 30 29 28.654 29 27V15C29 13.346 27.654 12 26 12Z",
    fill: "#661C69"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateImO);
export default __webpack_public_path__ + "static/media/DateImO.d50b1d98c4df710287ea426d25baa28b.svg";
export { ForwardRef as ReactComponent };